import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scroll-buttons"
export default class extends Controller {
  static targets = ["content"]
  static values = {
    step: { type: Number, default: 100 }
  }


  connect() {
    this.updateButtons()
    window.addEventListener("resize", this.updateButtons)
  }

  disconnect() {
    window.removeEventListener("resize", this.updateButtons)
  }

  scrollLeft() {
    this.scroll(-this.stepValue)
  }

  scrollRight() {
    this.scroll(this.stepValue)
  }

  scroll(amount) {
    this.contentTarget.scrollBy({
      left: amount,
      behavior: "smooth"
    })
  }

  updateButtons = () => {
    const hasOverflow =
      this.contentTarget.scrollWidth > this.contentTarget.clientWidth

    this.element
      .querySelectorAll(".scroll-left, .scroll-right")
      .forEach(button => {
        button.style.display = hasOverflow ? "" : "none"
      })
  }
}
